<template>
    <div id="LPersonal">
        <div class="LBanner LWidth">
            <img src="../../../assets/img/index/21.png" alt="" />
        </div>
        <!--  -->
        <div class="LWidth">
            <div class="Lbread">
                <Breadcrumb separator=">">
                    <BreadcrumbItem to="/index">首页</BreadcrumbItem>
                    <BreadcrumbItem>教材征订</BreadcrumbItem>
                    <BreadcrumbItem>{{solicit}}</BreadcrumbItem>
                </Breadcrumb>
            </div>
            <div class="lConter">
                <!-- 左侧 -->
                <div class="lConterLeft">
                    <div class="lLfetTitle">
                        <div class="ltitleImg">
                            <img
                                src="https://medoss.oss-cn-shanghai.aliyuncs.com/uploads/1624345784212.png"
                                alt=""
                            />
                        </div>
                        <p class="lTile">教材征订</p>
                    </div>
                    <div  class="LMenu">
                        <ul>
                            <li v-for="(item,i) in menu" :key="i" >
                                <div  v-if="item.title !== '继续教育' && type == 1 && item.title !== '学时查询' && type == 1 && item.title !== '证书管理' && type == 1 || type !== 0">
                                    <div class="oneMenu" @click="oneMenuClick(item,i)">
                                        <div class="oneMenuLeft" :class="{oneMenuLeftAtiv:item.title==oneMenu}"></div>
                                        <div>
                                            <router-link  class="oneMenuText" :class="{oneMenuTextAtiv:item.title==oneMenu}"  :to="item.to">{{item.title}}</router-link>
                                        </div>
                                    </div>
                                    <ul class="towMenu" :class="{towMenuBlock:item.title==oneMenu}">
                                        <li v-for="(res,index) in item.children" :key="index" >
                                            <span @click="towMenuClick(res.title,index)" >
                                                <router-link class="routa" ref="routa" :class="{towMenuA:res.title==twoMenu}"  :to="res.to">{{res.title}}</router-link>
                                            </span>
                                        </li>
                                        <!-- <li><a href="#">快递地址</a></li>
                                        <li><a href="#">发票抬头</a></li> -->
                                    </ul>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- 右侧 -->
                <div class="lConterRight">
                    
                    <!-- 右侧的视图核心 -->
                    <router-view @editPage="editPage"></router-view>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Cookies from "js-cookie";
import { checkSolicitStatus} from "network/home";

export default {
    name:'teachingBook',
    data() {
        return {
            menu:[
                {
                    title:'药学初中资格考试征订',
                    to:'/teachingBookPage1',
                    children:[]
                },
                {
                    title:'医疗器械初中资格考试征订', 
                    to:'/teachingBookPage3',
                    children:[]
                },
                {
                    title:'中药炮制规范征订',
                    to:"/teachingBookPage2",
                    children:[]
                },
            ],
            bmenu: [
                {
                    title:'药学初中资格考试征订',
                    to:'/teachingBookPage1',
                    children:[]
                },
                {
                    title:'医疗器械初中资格考试征订', 
                    to:'/teachingBookPage3',
                    children:[]
                },
                {
                    title:'中药炮制规范征订',
                    to:"/teachingBookPage2",
                    children:[]
                },
            ],
            oneMenu:'账户资料',
            twoMenu:'个人信息',
            type: null,
            solicit: '药学初中资格考试征订'
        };
    },
    activated(){
        this.type = this.Get('type')
        this.linkTo(0);
        this.linkTo(1);
        this.linkTo(2);
    },
    methods: {
        linkTo(i){
            checkSolicitStatus(i+1)
            .then(res => {
                console.log(res,'++++++++++++++++')
                if(res.data.code == 200){
                    this.menu[i] = this.bmenu[i]
                }
                else{
                    this.menu[i].to = ''
                }
            })
        },
        
        Get(name) {
        return Cookies.get(`admin-${name}`);
        },
        editPage(val1, val2) { // 子级更改了页面
            console.error(val1, val2);
            this.oneMenu = val1;
            this.twoMenu = val2;
        },
        // 点击一级菜单
        oneMenuClick(val,i){
            console.log(val,"***")
            checkSolicitStatus(i+1)
            .then(res => {
                if(res.data.code == 200){
                    this.oneMenu=val.title;
                    this.solicit = val.title;
                }
                else{
                    this.$Message['error']({
                        background: true,
                        content: '十分抱歉！教材征订暂未开始，请耐心关注征订开始时间',
                        duration: 5
                    });
                }
            })
        },
        towMenuClick(val,i){
            console.log(val,"***")
            checkSolicitStatus(i+1)
            .then(res => {
                if(res.data.code == 200){
                    this.twoMenu=val;
                }
                else{
                    this.$Message['error']({
                        background: true,
                        content: '十分抱歉！教材征订暂未开始，请耐心关注征订开始时间',
                        duration: 5
                    });
                }
            })
        },
        
    },
};
</script>

<style scoped>
@import url("../../../assets/css/liucss/LPersonal.css");
.LMenu ul li .oneMenu{
    width: auto;
    justify-content: flex-start;
}
.oneMenuText{
    font-size: 14px;
    color: #333;
    margin-left: 19px;
}
.lLfetTitle{
    align-items: center;
}

    img{
        border-style: none;
        width: 100%;
        height: 100%;
    }
</style>